import { render, staticRenderFns } from "./Recount__plotsBvTax.vue?vue&type=template&id=0899efa2&scoped=true&"
import script from "./Recount__plotsBvTax.vue?vue&type=script&lang=js&"
export * from "./Recount__plotsBvTax.vue?vue&type=script&lang=js&"
import style0 from "@/style/grid.css?vue&type=style&index=0&id=0899efa2&scoped=true&lang=css&"
import style1 from "@/style/button.css?vue&type=style&index=1&id=0899efa2&scoped=true&lang=css&"
import style2 from "./Recount__plotsBvTax.vue?vue&type=style&index=2&id=0899efa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0899efa2",
  null
  
)

export default component.exports